export default "__VITE_ASSET__2bc65cbb__"